import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      emofUserTokenSafer: '',
      cookie_user: '',
      user: '',
      o_mid: '',
  },
  mutations: {
      increment(state) {
          // 变更状态
          state.emofUserTokenSafer = ''
          state.user = ''
          state.cookie_user = ''
      },
      setUserInfo(state,data){
          state.user = data
      }
  },
  actions: {
      LogOut(context) {
          context.commit('increment')
      },
      setUserInfo(context,data) {
          context.commit('setUserInfo',data)
      },
  },
  modules: {
  }
})
